import { createContext } from 'react';
import { LayoutContextValue } from './LayoutContextValue';

export const LayoutContext = createContext<LayoutContextValue>(null);

LayoutContext.displayName = 'V1 Header';
